import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function IssueIndentEqp() {

  const {id}=useParams();
  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0,10);
  const [errorMsg, seterrorMsg] = useState('');
  const [succesMsg, setsuccessMsg] = useState('');
  const [eqpData, setEqpData] = useState([]);
  const [registerFormData, setRegisterFormData] = useState({
        "qty":'',
        "addedby":'',
        "ip_add":'',
    });
    useEffect(() => {
        try{
            axios.get(baseUrl+'update-indent-eqp/'+id+'/')
            .then(function (response) {
                setRegisterFormData({
                    productid:response.data.product.id,
                    product:response.data.product.product,
                    qty:response.data.qty,
                    issued_qty:response.data.issued_qty,
                });
            });
        }catch(error){
            console.log(error);
        }
    },[]);
    useEffect(() => {
      try {
        const eqid = registerFormData?.productid;
        if (eqid) {
          axios.get(baseUrl + 'update-eqp-qty/' + eqid + '/')
            .then(function (response) {
              setEqpData({
                totqty: response.data.totqty,
              });
            });
        }
      } catch (error) {
        console.log(error);
      }
    }, [registerFormData]);

const handleChange = (event) => {
    const { name, value } = event.target;
    setRegisterFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    let newValue = Number(value);

    if (name === 'issued_qty') {
      const min = 1;
      const max = registerFormData.qty;

      // Apply min-max constraints only when input loses focus
      if (newValue < min) {
        newValue = min;
      } else if (newValue > max) {
        newValue = max;
      }

      setRegisterFormData((prevFormData) => ({
        ...prevFormData,
        [name]: newValue
      }));
    }
  };

  const submitHandler = (e) => {
     e.preventDefault();


        const formData = new FormData();
        formData.append('issued_qty', registerFormData.issued_qty);
        formData.append('issued_by', userName);
        formData.append('issued_on', formattedDate);
        formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);

        axios.put(baseUrl+'update-indent-eqp/'+id+'/', formData)
          .then((response) => {
              if(response.status==200 || response.status==201){

                   const totqty = parseInt(eqpData.totqty) - parseInt(registerFormData.issued_qty);
                   const eqid = registerFormData.productid;

                   const pharmData = {
                        totqty: totqty,
                        ip_add: ipAddress,
                      };
                axios.put(baseUrl+'update-eqp-qty/'+eqid+'/', pharmData)
                   .then((response) => {
                        console.log(response.data);
                   });
                Swal.fire({
                  title: 'Qty has been Updated.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/indent-eqp-list';
                }, 3000);
              }
            })
              .catch(error => {
              console.log(error);
                  Swal.fire(
                    'Error!',
                    'Failed to add. Please try again later.',
                    'error'
                  );
              });
  };

  return (
        <section className="container mt-4">
            <div className="row">
              <div className="col-md-8 col-12">
                <div className='card'>
                    <h4 className='card-header text-center'>Issue Equipment Qty</h4>
                    <div className='card-body'>
                        <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                        {succesMsg && <p className="text-success">{succesMsg}</p>}
                        {errorMsg && <p className="text-danger">{errorMsg}</p>}
                        <form>

                        <div className="row">
                        <div className="col-md-4 mb-3">
                            <label htmlFor="TQty" className="form-label">Product</label><br />
                            {registerFormData.product}
                            <input type="number" style={{display: 'none'}} className="form-control"
                                name="productid" value={registerFormData.productid} onChange={handleChange} />
                        </div>
                        <div className="col-md-2 mb-3">
                        <label htmlFor="TQty" className="form-label">TotQty - Store</label><br />
                            {eqpData.totqty}
                        </div>
                        <div className="col-md-2 mb-3">
                            <label htmlFor="TQty" className="form-label">Raised Qty</label>
                            <input type="number"  placeholder="TQty" className="form-control"
                                name="qty" value={registerFormData.qty}  readOnly/>
                        </div>
                        <div className="col-md-2 mb-3">
                            <label htmlFor="TQty" className="form-label">TQty</label>
                            <input
                              type="number"
                              maxLength={10}
                              placeholder="TQty"
                              className="form-control"
                              name="issued_qty"
                              min="1"
                            max={registerFormData.qty}
                            value={registerFormData.issued_qty}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            />
                        </div>
                        </div>

                        <div className="row">
                        <div className="col-md-12 text-center">
                        <button type="button" onClick={submitHandler}
                        className="btn btn-success">Allocate</button>
                        </div>
                        </div>
                        </form>
                    </div>
                </div>
              </div>
            </div>
        </section>
  );
}

export default IssueIndentEqp;
